export default __webpack_public_path__ + "static/media/2.241e746e.mp4";